export const minutes = (n: number) => n * 60 * 1000;
export const seconds = (n: number) => n * 1000;
export const hours = (n: number) => n * 60 * 60 * 1000;
